export enum FindPeopleSortBy {
   ADDRESS_1 = "address_1",
   ADDRESS_2 = "address_2",
   CAN_RECIEVE_EMAIL = "can_recieve_email",
   CAN_RECIEVE_MOBILE = "can_recieve_mobile",
   CAN_RECIEVE_SMS = "can_recieve_sms",
   CITY_TOWN = "city_town",
   COUNTRY = "country",
   CUSTOM_FIELD = "custom_field",
   DOB = "dob",
   EMAIL = "email",
   EMPLOYEE_NUMBER = "employee_number",
   HAS_PROCORE_MAPPING = "has_procore_mapping",
   HIRED_DATE = "hired_date",
   HOURLY_WAGE = "hourly_wage",
   JOB_TITLE = "position",
   LANGUAGE = "language",
   PERMISSION = "permission",
   PERSON_NAME_FIRST = "person_name_first",
   PERSON_NAME_LAST = "person_name_last",
   PERSON_STATUS = "status",
   PHONE = "phone",
   STATE_PROVINCE = "state_province",
   ZIPCODE = "zipcode",
   NOTIFICATION_PROFILE = "notification_profile_id",
   CURRENT_ASSIGNMENTS = "current_assignments",
   CURRENT_ASSIGNMENTS_END_DATE = "current_assignments_to",
   CURRENT_ASSIGNMENTS_JOB_NUMBER = "current_assignments_job_number",
   CURRENT_ASSIGNMENTS_START_DATE = "current_assignments_from",
   NEXT_ASSIGNMENT = "next_assignment",
   NEXT_ASSIGNMENT_END_DATE = "next_assignment_to",
   NEXT_ASSIGNMENT_JOB_NUMBER = "next_assignment_job_number",
   NEXT_ASSIGNMENT_START_DATE = "next_assignment_from",
}

export enum FieldMapping {
   DOB = "dob",
   HIRED_DATE = "hired_date",
   GENDER = "gender",
   HOURLY_WAGE = "hourly_wage",
   EMAIL = "email",
   EMPLOYEE_NUMBER = "employee_number",
   STATUS = "status",
   PHONE = "phone",
   GROUPS = "groups",
   JOB_TITLE = "job_title_id",
   TYPE = "type",
   PERMISSION = "permission",
   NOTIFICATION_PROFILE = "notification_profile",
   LANGUAGE = "language",
}
